/**
 * ============================================================================
 *  File        : frontend/src/pages/UnderConstruction.tsx
 *  Module      : pages
 *  Purpose     : 施工中 placeholder — 讓 spec §8.2 路由先可達，標示對應規格段落
 *  Author      : EF Engineering
 *  Created     : 2026-05-31
 *  Updated     : 2026-05-31
 *  License     : Proprietary - ECO FAITH Platform v3.0
 * ============================================================================
 */

import { Construction } from 'lucide-react'
import type { ReactElement } from 'react'
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../components/ui/card'
import { Badge } from '../components/ui/badge'

interface UnderConstructionProps {
  /** 已翻譯的頁面標題。 */
  title: string
  /** 目前路由（顯示用）。 */
  route: string
  /** 對應 spec 規格段落，例如 「spec §8.2 /cases/:id/items」。 */
  specSection: string
  /** 已翻譯的「施工中」標籤。 */
  underConstructionLabel: string
  /** 已翻譯的說明文案。 */
  description: string
}

export function UnderConstruction({
  title,
  route,
  specSection,
  underConstructionLabel,
  description,
}: UnderConstructionProps): ReactElement {
  return (
    <section className="page-stack">
      <Card className="mx-auto w-full max-w-2xl">
        <CardHeader>
          <div className="flex items-center gap-3">
            <Construction aria-hidden="true" className="text-muted-foreground" size={28} />
            <div className="flex flex-1 flex-col gap-1">
              <div className="flex items-center gap-2">
                <CardTitle>{title}</CardTitle>
                <Badge variant="secondary">{underConstructionLabel}</Badge>
              </div>
              <CardDescription>{description}</CardDescription>
            </div>
          </div>
        </CardHeader>
        <CardContent className="space-y-2 text-sm text-muted-foreground">
          <p>
            <span className="font-medium text-foreground">Route:</span> <code>{route}</code>
          </p>
          <p>
            <span className="font-medium text-foreground">Spec:</span> {specSection}
          </p>
        </CardContent>
      </Card>
    </section>
  )
}
